import { format, isValid } from 'date-fns';

import { CALENDAR_DATE_FORMAT } from 'src/constants';
import { IDataState } from './types';

export const formatDate = (dateString: string): string => {
  if (!dateString) return '';

  try {
    const parts = dateString.trim().split(' ');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

      if (!isValid(date)) {
        return dateString;
      }

      return format(date, CALENDAR_DATE_FORMAT);
    } else {
      const date = new Date(dateString);

      if (!isValid(date)) {
        return dateString;
      }

      return format(date, CALENDAR_DATE_FORMAT);
    }
  } catch (error) {
    console.warn('Error formatting date:', dateString, error);
    return dateString;
  }
};

export const isDataLoaded = (
  dataKey: string,
  props: Record<string, IDataState>,
): boolean => {
  return props[dataKey].data !== null;
};

export const matchesSearch = (name: string, searchQuery: string): boolean => {
  if (!searchQuery) return true;
  return name.toLowerCase().includes(searchQuery.toLowerCase());
};

export const resolveActiveGroupName = (
  groups: Array<{ name: string }>,
  activeGroup: string,
): string | null => {
  const groupKeys = groups.map(group => group.name);
  const activeGroupIndex = groupKeys.indexOf(activeGroup);

  if (activeGroupIndex !== -1) return groups[activeGroupIndex].name;
  return groupKeys.length > 0 ? groups[0].name : null;
};
